module.exports = __webpack_public_path__ + "img/ta.ta56f5577.svg";